import type { PropsWithChildren } from 'react';
import React from 'react';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { color } from '@nuvolo/nuux-theme/utils';

interface ItemProps extends PropsWithChildren {
  hideBorder?: boolean;
}

const Item: React.FC<ItemProps> = ({ children, hideBorder }) => (
  <NuvoBox
    display="flex"
    flexDirection="column"
    gap={12}
    backgroundColor={color('custom', 'dataGridBackground')}
    padding={12}
    border={hideBorder ? 'none' : `1px solid ${color('ui', 'light2')}`}
    borderRadius="4px"
    height="100%">
    {children}
  </NuvoBox>
);

export default React.memo(Item);
